import { memo, useContext, useEffect, useState } from 'react';

import { useForm } from 'react-hook-form';
import Cookies from 'universal-cookie';

import Breadcrumb from '@/components/atoms/breadcrumb/breadcrumb';
import GenericToast from '@/components/atoms/generic-toast/genericToast';
import Loader from '@/components/atoms/loader/loader';
import Modal from '@/components/atoms/modal/modal';
import CommunicationChannels from '@/components/molecules/communication-channels/communicationChannels';
import ModalRequestShift from '@/components/molecules/modal-request-shift/modalRequestShift';
import PaymentStepper from '@/components/molecules/payment-stepper/payment-stepper';
import RequestFormShift from '@/components/molecules/request-form-shift/requestFormShift';
import ShiftServiceBranch from '@/components/molecules/shift-service-branch/shiftServiceBranch';
import ShiftRequestResult from '@/components/organisms/shift-request-result/shiftRequestResult';
import GlobalContext from '@/contexts/globalContext';
import { TabsEnum, DocumentType } from '@/enums/enums';
import UseTraceItemShipping from '@/hooks/UseTraceItemShipping';
import { IListInfoTickets, InfoTicketShift } from '@/interfaces/qanty';
import {
  cancelTicketShift,
  createShift,
  getShiftBranches,
  getShiftService,
  getTicketShift,
} from '@/services/qanty-service';
import { validateNullOrUndefined } from '@/utils/validateNullOrUndefined';

import { postLegal } from '../../../services/certificate-services';
import listTypeDocLegal from '../../../utils/typeDocLegal.json';
import FormAndNoteTemplate from '../form-and-note-template/formAndNoteTemplate';

import './requestShiftsContent.scss';

const MemoRequestShiftsContent = ({ contentInfo }) => {
  const { selectedTab, gigyaContext, userInfoContext } = useContext(GlobalContext);
  const [ticketId, setTicketId] = useState('');
  const [isTicket, setIsTicket] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [isShowModal, setIsShowModal] = useState(false);
  const [isAccept, setIsAccept] = useState(false);
  const [isLoadingButtonCreate, setIsLoadingButtonCreate] = useState(false);
  const [isLoadingButtonCancel, setIsLoadingButtonCancel] = useState(false);
  const [isLoadingSelectBranch, setIsLoadingSelectBranch] = useState(false);
  const [isChecksReady, setIsChecksReady] = useState(false);
  const [turnsOnFront, setTurnsOnFront] = useState(0);
  const [timerOnFront, setTimerOnFront] = useState(0);
  const [openToast, setOpenToast] = useState<any>(false);
  const [listBranch, setListBranch] = useState([] as any);
  const [isLoading, setIsLoading] = useState(false);
  const [listInfoService, setListInfoService] = useState([] as any);
  const [isLogin, setIsLogin] = useState(false);
  const cookies = new Cookies();
  const [listPreviewInfoTicket, setListPreviewInfoTicket] = useState<IListInfoTickets>({
    success: false,
    info: {} as InfoTicketShift,
  });
  const [bodyForm, setBodyForm] = useState({
    sede: '',
    service: '',
    docNumber: '',
    documentType: '',
    lastName: '',
    name: '',
  });

  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    clearErrors,
  } = useForm();

  const formInfoSelect = contentInfo.referencias[2];
  const resultInfo = contentInfo.referencias[3];
  const resultContentTwo = contentInfo.referencias[4];
  const modalContent = contentInfo.modal;
  const listTitlesSteps = [...contentInfo.lista].slice(0, 2);

  const toastMessageError = (message: string, isError?: boolean) => {
    return setOpenToast(
      <GenericToast
        message={message}
        position="up-right-small"
        setActiveToast={setOpenToast}
        size="small"
        isOk={isError ?? false}
      />,
    );
  };

  const getListBranch = async () => {
    setIsLoadingSelectBranch(true);
    setIsLoading(true);
    try {
      const response = await getShiftBranches();
      if (response.status !== 200) {
        setIsLoadingSelectBranch(false);
        setIsLoading(false);
        return toastMessageError('Error al cargar las sedes');
      }
      if (response.data.status !== 200) {
        setIsLoadingSelectBranch(false);
        setIsLoading(false);
        return toastMessageError(response.data.userMessage);
      }

      if (response.data === 500 || response.data.status === 500) {
        setIsLoadingSelectBranch(false);
        setIsLoading(false);
        window.location.reload();
      }

      const data = response.data.data?.sites
        .map((item) => ({
          ...item,
          value: item.id,
          name: item?.name_customed,
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
      setListBranch(data);
      setIsLoadingSelectBranch(false);
      setIsLoading(false);
    } catch (error) {
      setIsLoadingSelectBranch(false);
      setIsLoading(false);
      const typedError = error as Error;
      toastMessageError(typedError?.message || 'Error al obtener las sedes');
    }
  };

  useEffect(() => {
    getListBranch();
    return () => {
      setListBranch([]);
    };
  }, []);

  useEffect(() => {
    if (gigyaContext.gigyaAccount) {
      setIsLogin(true);
    }
  }, []);

  useEffect(() => {
    const chosenService = listInfoService.find((n) => n.value === getValues('service'));
    const chosenBranch = listBranch.find((n) => n.id === getValues('sede'));
    const newListInfoTickets = {
      success: chosenService?.enabled,
      info: {
        name: '',
        branch: {
          id: getValues('sede'),
          name: chosenBranch?.name,
          address: chosenBranch?.location?.address,
        },
        current_line: {
          name: chosenService?.name,
          id: '',
        },
        wait_metrics: {
          wait_estimate: chosenService?.metrics?.waiting_time_estimation ?? 0,
          tickets_in_front: chosenService?.waiting_tickets ?? 0,
        },
      },
    } as IListInfoTickets;
    setListPreviewInfoTicket(newListInfoTickets);
  }, [getValues('service')]);

  useEffect(() => {
    const ticketData = localStorage.getItem('ticketId');
    if (!ticketData) {
      let count = 0;
      let timer = 0;
      listInfoService.forEach((element) => {
        count += element.waiting_tickets;
        timer += element.metrics.waiting_time_estimation;
      });
      setTurnsOnFront(count);
      setTimerOnFront(timer);
    }
  }, [listInfoService]);

  const backStepper = () => {
    setCurrentStep(0);
  };

  const onSubmitForm = async (body) => {
    const userTypeDoc = await Object?.entries(DocumentType)?.find((el) => {
      return el?.[0] === body?.documentType;
    })?.[0];
    if (!isLogin) {
      const userTypeDoc = Object?.entries(DocumentType)?.find((el) => {
        return el?.[0] === body?.documentType;
      })?.[1];
      body.documentType = userTypeDoc;
      setBodyForm(body);
      const typeDocument = listTypeDocLegal.find((el) => {
        return el.typaDocSAP === userTypeDoc;
      })?.legal;
      postLegal(body.docNumber, typeDocument, 'aleatorio@gmail.com');
    } else {
      setBodyForm(body);
    }
    if (currentStep === 0) {
      if (isLogin) {
        UseTraceItemShipping(
          `${gigyaContext?.gigyaAccount?.profile.firstName} ${
            gigyaContext?.gigyaAccount?.data.secondName
              ? `${gigyaContext.gigyaAccount.data.secondName} `
              : ''
          }${gigyaContext?.gigyaAccount?.profile.lastName}${
            gigyaContext?.gigyaAccount?.data.secondLastName
              ? ` ${gigyaContext?.gigyaAccount?.data.secondLastName}`
              : ''
          }`,
          gigyaContext?.gigyaAccount?.data.docNumber,
          gigyaContext?.gigyaAccount?.data.docType,
          gigyaContext?.gigyaAccount?.profile.email,
          'click',
          'SolicitudDeTurnos :: SolicitudDeTurnos :: } ClickBotonContinuar',
          userInfoContext.data?.userJwt,
        );
      } else if (userTypeDoc) {
        UseTraceItemShipping(
          `${body.name} ${body.lastName}`,
          body.docNumber,
          userTypeDoc,
          'usuarioNoLogeado@gmail.com',
          'click',
          'SolicitudDeTurnos :: SolicitudDeTurnos :: } ClickBotonContinuar',
          cookies.get('token'),
        );
      }
      setCurrentStep(0.9);
      return;
    }
    setCurrentStep(2);
  };

  const onCancelShiftModal = async () => {
    try {
      if (!ticketId) {
        return;
      }
      setIsLoadingButtonCancel(true);
      const response = await cancelTicketShift(ticketId);
      const { data } = response;
      if (data.status !== 200) {
        return toastMessageError(data.userMessage);
      }
      localStorage.removeItem('ticketId');
    } catch (error) {
      console.error(error);
      const typedError = error as Error;
      toastMessageError(typedError?.message || 'Error al cancelar el turno');
    } finally {
      if (!gigyaContext?.gigyaAccount) {
        reset();
      }
      setIsShowModal(false);
      setCurrentStep(0);
      setListPreviewInfoTicket({
        success: false,
        info: {} as any,
      });
      setTicketId('');
      setIsTicket(false);
      setIsLoadingButtonCancel(false);
    }
  };

  const onCreateShift = async () => {
    try {
      if (ticketId) {
        return toastMessageError('Ya tienes un turno creado', true);
      }
      setIsAccept(true);
      setIsLoadingButtonCreate(true);
      const response = await createShift({
        branch_id: bodyForm?.sede,
        line_id: bodyForm?.service,
        customer: {
          doc_id: bodyForm?.docNumber,
          doc_type: bodyForm?.documentType,
          last_name: validateNullOrUndefined(bodyForm?.lastName),
          name: bodyForm?.name,
        },
      });
      const { data } = response;
      if (data.status !== 200) {
        return toastMessageError(data.userMessage);
      }
      setIsShowModal(true);
      setListPreviewInfoTicket({
        ...listPreviewInfoTicket,
        info: {
          ...listPreviewInfoTicket.info,
          name: data.data?.ticket_name,
        } as InfoTicketShift,
      });
      setTicketId(data.data?.ticket_id);
      localStorage.setItem('ticketId', data.data?.ticket_id);
      setIsTicket(true);
    } catch (error) {
      console.error(error);
      const typedError = error as Error;
      toastMessageError(typedError?.message || 'Error al crear el turno');
    } finally {
      setIsLoadingButtonCreate(false);
    }
  };

  const onButtonBack = () => {
    if (!ticketId) {
      setCurrentStep(0);
      return;
    }
    setIsShowModal(true);
    setIsAccept(false);
  };

  const dynamicText = {
    0: {
      title: contentInfo.referencias[1].titulo,
      subtitle: contentInfo.referencias[1].subtitulo,
    },
    0.9: {
      title: contentInfo.referencias[2].titulo,
      subtitle: contentInfo.referencias[2].subtitulo,
    },
  };

  useEffect(() => {
    const tab = localStorage.getItem('CURRENT_TAB');
    if (!tab) {
      location.href =
        window?.location.hostname === 'localhost' ? '/personas' : '/portal-servicios/personas';
      return;
    }

    if (tab === TabsEnum.BUSINESS) {
      location.href =
        window?.location.hostname === 'localhost' ? '/empresas' : '/portal-servicios/empresas';
    }
  }, [selectedTab?.get]);

  useEffect(() => {
    window?.scroll(0, 0);
    const ticketData = localStorage.getItem('ticketId');
    if (ticketData) {
      setIsLoading(true);
      setTicketId(ticketData);
      getTicketShift(ticketData)
        .then((response) => {
          if (response.status === 200 && response.data.status === 200) {
            if (response.data.data.info.status === 'WAITING') {
              getShiftService({
                branchId: response.data.data.info.branch.id,
              }).then((res) => {
                let count = 0;
                let timer = 0;
                res.data.data.lines.forEach((element) => {
                  count += element.waiting_tickets;
                  timer += element.metrics.waiting_time_estimation;
                });
                setTurnsOnFront(count);
                setTimerOnFront(timer);
              });
              setTurnsOnFront(response.data.data.info.branch.waiting_tickets);
              setIsTicket(true);
              setListPreviewInfoTicket(response.data.data);
              setCurrentStep(2);
              setIsLoading(false);
            } else {
              setIsLoading(false);
              localStorage.removeItem('ticketId');
            }
          }

          if (response.data === 500) {
            window.location.reload();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, []);

  const getCurrentStep = () => {
    const currentComponentStep = {
      0: (
        <RequestFormShift
          contentInfo={contentInfo}
          register={register}
          setValue={setValue}
          handleSubmit={handleSubmit}
          errors={errors}
          getValues={getValues}
          reset={reset}
          setIsChecksReady={setIsChecksReady}
        />
      ),

      0.9: (
        <ShiftServiceBranch
          handleSubmit={handleSubmit}
          register={register}
          setValue={setValue}
          errors={errors}
          getValues={getValues}
          listBranch={listBranch}
          isLoadingSelectBranch={isLoadingSelectBranch}
          setListInfoService={setListInfoService}
          clearErrors={clearErrors}
        />
      ),
    };

    return currentComponentStep[currentStep];
  };

  return (
    <div className="o-request-shifts-content">
      {openToast && <>{openToast}</>}
      <div className="o-request-shifts-content__header">
        <Breadcrumb content={contentInfo.migaDePan} />
        <PaymentStepper
          itemList={listTitlesSteps}
          currentIndex={currentStep === 0 || currentStep === 0.1 ? 0 : currentStep}
          title={contentInfo.nombre}
          subtitle={contentInfo.subtitulo}
          titleType="h1"
          isTwo
        />
      </div>

      {currentStep < 1 && !isLoading ? (
        <FormAndNoteTemplate
          buttonCopy={contentInfo.referencias[1].boton[0].copy}
          buttonTwo={contentInfo.referencias[2].boton[0].copy}
          buttonEvent={() => {
            handleSubmit(onSubmitForm)();
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'pushEventGA',
              category: 'HomePersonas',
              action: 'ClicSolicitudTurnos',
              label: `Paso ${currentStep === 0.9 ? '1' : '2'} continuar`,
            });
          }}
          buttonEventTwo={() => {
            backStepper();
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'pushEventGA',
              category: 'HomePersonas',
              action: 'ClicSolicitudTurnos',
              label: 'Paso 2 Volver',
            });
          }}
          secondTitle={dynamicText[currentStep].title}
          secondSubtitle={dynamicText[currentStep].subtitle}
          note={{
            image: contentInfo.referencias[0].imagen[0],
            title: contentInfo.referencias[0].titulo,
            content: contentInfo.referencias[0].descripcion,
          }}
          notePosition="left"
          disableButton={!isChecksReady}
          isSecondButton={currentStep === 0.9}
          subRoute="solicitud-de-turnos"
        >
          {getCurrentStep()}
        </FormAndNoteTemplate>
      ) : (
        currentStep < 1 && <Loader size="medium" />
      )}
      {currentStep === 0.9 && (
        <CommunicationChannels
          listChannels={formInfoSelect.secciones[0].referencias}
          title={formInfoSelect.secciones[0].titulo}
          subtitle={formInfoSelect.secciones[0].subtitulo}
        />
      )}
      {currentStep === 2 && (
        <>
          {isLoading ? (
            <Loader size="big" />
          ) : (
            <ShiftRequestResult
              turnText={resultInfo.titulo}
              textTimerStatus={resultInfo.subtitulo}
              image={resultInfo.imagen[0]}
              shiftInfoTitle={resultContentTwo.titulo}
              shiftInfoSubtitle={resultContentTwo.subtitulo}
              listContent={resultContentTwo}
              listResponse={listPreviewInfoTicket}
              onClickNext={() => onCreateShift()}
              onClickPrevious={() => onButtonBack()}
              loaderAccept={isLoadingButtonCreate}
              ticketsOnFront={turnsOnFront}
              timerOnFront={timerOnFront}
              ticketId={isTicket}
            />
          )}
        </>
      )}

      {isShowModal && (
        <Modal
          open={isShowModal}
          onClose={() => {
            setIsShowModal(false);
          }}
        >
          <ModalRequestShift
            modalContent={modalContent}
            onClose={() => {
              setIsShowModal(false);
            }}
            onCancel={() => setIsShowModal(false)}
            onAccept={() => setIsShowModal(false)}
            onAcceptCancel={() => onCancelShiftModal()}
            isAccept={isAccept}
            loader={isLoadingButtonCancel}
            listInfo={listPreviewInfoTicket}
          />
        </Modal>
      )}
    </div>
  );
};

const RequestShiftsContent = memo(MemoRequestShiftsContent);

export default RequestShiftsContent;
